<template>
  <div class="box">
    <div class="top">
      <h1 class="testName">2020年省考模拟题（一）</h1>
      <p class="testRequire mt-5">本试卷总题数60题，卷面总分120分，答题时间40分钟。</p>
    </div>
    <div class="center">
      <div class="left">
        <ul>
          <li>
            <p class="name"><i class="one">1</i>/<i class="all">15</i> <a class="type">单选题</a> 《中华人名共和国建设工程质量管理条例》属于<i class="answer">(&nbsp;&nbsp;&nbsp;&nbsp;)</i>.</p>
            <div>
              <el-radio-group v-model="radio">
                <el-radio :label="3">备选项</el-radio>
                <el-radio :label="6">备选项</el-radio>
                <el-radio :label="9">备选项</el-radio>
                <el-radio :label="12">备选项</el-radio>
              </el-radio-group>
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <ul>
          <li class="oneli">
            <i class="el-icon-time mr-10"></i>倒计时<i class="ml-10 endTime">00:44:59</i>
          </li>
          <li class="oneli">
           答题卡<i class="ml-10 progress">2/15</i>
          </li>
          <li class="twoli">
            <p class="testType">单项选择题</p>
            <div class="chooseAll">
              <ul class="chooseBox">
                <li>1</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
                <li>1</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>2</li>
                <li>6</li>
                <li>2</li>
                <li>2</li>
              </ul>
            </div>
          </li>
          <li class="clear"></li>
          <li class="doPart">
            <ul>
              <li class="finished"><p></p><i>已做</i></li>
              <li class="notfinish"><p></p><i>未做</i></li>
              <li class="tips"><p></p><i>标记</i></li>
            </ul>
          </li>
          <li class="clear"></li>
          <li>
            <el-button plain>保存，下次继续</el-button>
          </li>
          <li>
            <el-button type="primary" @click="dialogVisible=true">交卷</el-button>
          </li>
        </ul>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <span>这是一段信息</span>
        <span slot="footer" class="dialog-footer">
         <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
 data(){
   return{
     radio:'',
     dialogVisible:false,
   }
 },
 methods:{
   handleClose(){
     this.dialogVisible=false
   }
 }
}
</script>

<style scoped>
.top{text-align: center;height:120px;background-color: #fff;}
.testName{color: #4b567c;font-size:30px;padding-top: 28px;}
.center{display: flex;width:100%;margin-top: 10px;position: relative;perspective:1px;}
.left{width:70%;height: 770px;}
.left>ul{width: 100%;height:100%;}
.left li{width: 100%;background: #fff; padding: 20px 15px; text-align: left;margin-bottom: 15px;}
.right{ margin-left: 10px; background: #fff; width:277px; height:500px; position: fixed; right: 0px;}
.one{color: #4d7bef;font-size:20px;}
.type{color:#4d7bef ;}
.el-radio{display: flex; margin:20px 10px;}
.el-icon-time{color:#4d7bef;}
.right ul[data-v-e43c18bc] {text-align: left;padding: 15px;margin-top: 10px;}
.right .oneli{ border-bottom: 1px dashed #d7d7d7; height: 40px; line-height: 40px;}
.endTime{color: #4d7bef;font-weight: bold;}
.progress{color: #4d7bef;font-weight: bold;}
.testType{color:#333;padding-left: 10px;margin-top: 10px;border-left: 3px solid #4d7bef;}
.chooseAll{margin: 5px 0px 20px;height:140px;overflow-y: scroll;padding-bottom:20px;}
.chooseBox {padding: 15px 15px 0px;}
.chooseBox li{width:22px;height:20px;border:1px solid #d7d7d7;float: left; text-align: center;margin-right: 10px; margin-bottom: 10px;}
.clear{content:'';clear:both;}
.chooseAll::-webkit-scrollbar {/*滚动条整体样式*/width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/height: 1px;}
.chooseAll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/border-radius: 10px;box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);background   : #d7d7d7;}
.chooseAll::-webkit-scrollbar-track {/*滚动条里面轨道*/box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);border-radius: 10px;background   : #ededed;}
.finished,.notfinish,.tips {display: flex;align-items:center;}
.doPart{border-top:1px dashed #d7d7d7;margin-bottom: 25px;}
.doPart li{float: left;width:33%;text-align: center;}
.doPart p{width:15px;height:15px;}
.doPart i{ margin-left: 10px;}
.finished p {background:#4d7bef;}
.notfinish p{border: 1px solid #d7d7d7;}
.tips p{border: 1px solid #4d7bef;}
.center .el-button{width: 240px;height: 40px;margin-top: 10px;}
/deep/.el-button--primary.is-active,/deep/ .el-button--primary:active{border: #4d7bef;background: #4d7bef; color: #fff;}
.dialog .el-dialog__footer{text-align: center;}
</style>